export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";